<template>
  <div id="login">
    <div class="upper">
      <div class="logo">
        <img src="@/assets/se_text_logo.png" width="200" />
      </div>
      <form class="form" @submit.prevent="signupUser()">
        <InputText
          class="box"
          type="text"
          v-model="form.firstname"
          placeholder="First Name"
        />
        <InputText
          class="box"
          type="text"
          v-model="form.lastname"
          placeholder="Last Name"
        />
        <div class="p-input-icon-left">
          <i class="pi pi-user" />
          <InputText
            class="box"
            type="text"
            v-model="form.email"
            placeholder="Email"
          />
        </div>
        <div class="p-input-icon-left">
          <i class="pi pi-lock" />
          <InputText
            class="box"
            type="password"
            v-model="form.password"
            placeholder="Password"
          />
        </div>
        <Button class="login_button" label="Signup" type="submit" />
      </form>
    </div>
    <div class="lower">
      <router-link to="/login">BACK TO LOGIN</router-link>
    </div>
    <Toast position="bottom-right" />
  </div>
</template>

<script>
import { fb_auth, fb_users } from "../firebase";

export default {
  name: "Signup",
  data() {
    return {
      form: {
        email: null,
        password: null,
        firstname: null,
        lastname: null,
      },
    };
  },
  methods: {
    GoBack() {
      this.$router.push({ path: "/" });
    },
    signupUser() {
      if (this.form.email != null && this.form.password != null) {
        if (
          this.form.firstname != null && this.form.lastname != null
        ) {
          console.log('pased validation')
          fb_auth
            .createUserWithEmailAndPassword(
              this.form.email,
              this.form.password
            )
            .then((response) => {
              console.log("user auth created: ", response);
              // create user obj
              fb_users
                .doc(response.user.uid)
                .set({
                  firstname: this.form.firstname,
                  lastname: this.form.lastname,
                  email: this.form.email,
                  approved: false,
                })
                .then(() => {
                  this.$router.push("/AwaitingApproval");
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((error) => {
              // Handle Errors here.
              var errorCode = error.code;
              if (errorCode == "auth/wrong-password") {
                errorCode = "Incorrect Password";
              }
              var errorMessage = error.message;
              console.log(errorCode, errorMessage);
              this.$toast.add({
                severity: "error",
                summary: errorCode,
                detail: errorMessage,
                life: 3000,
              });
            });
        } else {
          if (this.form.firstname == null ||
          this.form.lastname == null) {
            this.$toast.add({
              severity: "warn",
              summary: "Incomplete",
              detail: "You must fill in your first and last name.",
              life: 3000,
            });
          }
        }
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Incomplete",
          detail: "You must fill out an email and password.",
          life: 3000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

#login {
  background: $primary;

  .upper {
    border-radius: 0px 0px 15px 15px;
    box-shadow: 3px 3px 6px #00000050;
    background: $white;
  }

  form {
    width: 75%;
    margin: 0 auto;
    max-width: 250px;

    .box {
      margin: 10px 0px;
    }

    .p-input-icon-left {
      width: 100%;
    }

    input {
      width: 100%;
    }
  }

  .login_button {
    width: 65%;
    margin: 20px auto;
    margin-bottom: 50px;
    font-weight: 700;
    color: $text;
  }

  .logo {
    padding: 20px 0px;
  }

  .lower {
    padding: 50px 0px;

    a,
    a:visited {
      color: white;
      text-decoration: none;
    }
  }
}
</style>